import { useEffect } from "react";
import { GridStack } from "gridstack";
import { useTranslation } from 'react-i18next';
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import ResourceViewForm from "./ResourceViewForm";
import DMSHeader from "../../DMSHeader/DMSHeader";

const ResourceView = () => {
  // Internationalization hooks for translation
  const { t } = useTranslation();

  // Initialize GridStack layout when component mounts
  useEffect(() => {
    GridStack.init();
  }, []);

  // Layout configuration for the grid items
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      component: (
        <DMSHeader
          title={t('View Resource Details')}
          fileName=""
          showmenu={true}
          showdownload={false}
          showIconsForback={true}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 2,
      component: <ResourceViewForm />,
    },
  ];
  return (
    // GridStack container with specific class names
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
      <GridItem layoutData={layoutData} />
    </div>
  );
}

export default ResourceView